import React from "react";
import { observer } from "mobx-react-lite";
import EventPass from "./EventPass";
import GoogleFooter from "../components/GoogleFooter";
import {getLabelColor} from "../utils";

const GoogleEventPass = observer(({store}) => {
  if (typeof store === "string"){
    store = JSON.parse(store);
  }
  const data = store?.eventTicket;

  const backgroundColor = data?.backgroundColor || "#FFFFFF";
  const foregroundColor = getLabelColor(backgroundColor);
  const labelColor = getLabelColor(backgroundColor);

  return (
    <EventPass
      store={{
        data,
        minHeight: "430px",
        backgroundColor,
        foregroundColor,
        labelColor,
        footer: <GoogleFooter barcodeType={data?.barcodeType} mobileWalletCode={data?.mobileWalletCode} />
      }}
    />
  );
});

export default GoogleEventPass;
